import {Component} from 'react';
import h from 'react-hyperscript';
import {eyebrow, p} from 'Components/Typography/Typography';
import BarChartVertical from 'Components/DataViz/BarCharts/BarChartVertical';
import AccordionItemHeader from './AccordionItemHeader/AccordionItemHeader';
import AccordionItemResources from './AccordionItemResources';
import {toCamelCase} from 'Src/utils/utils';
import surveyContent from 'Assets/data/survey.json';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import AccordianContentMinimal from './AccordianContentMinimal';
import {setZeroIfInvalidNumber} from 'Src/utils/utils';

export function OverviewDetail({item}) {
  return [
    h(eyebrow, {
      key: 'content__title_eyebrow',
      className: 'content__title',
    }, `${item.title} Overview`),
    h(p, {
      key: 'content__title_desc',
      className: 'text--grey content__desc',
    }, item.desc),
  ];
}

class AccordionItem extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = 'accordion__item';
    this.activeClasses = `${this.inactiveClasses} active`;
    this.handleLabelClick = this.handleLabelClick.bind(this);
    this.state = {
      activeStep: 'plan',
      resources: null,
      isExpanded: false,
      classes: this.inactiveClasses,
      topPick: null,
      isLoaded: false,
    };
  }

  componentWillMount() {
    this.checkIfExpanded();

    if (this.props.hasError) {
      this.setIsLoaded(true);
    } else {
      this.getElementResources();
      if (this.props.data) {
        this.getTopPickContent();
        this.checkIfPriority();
      } else {
        this.setIsLoaded(true);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.checkIfExpanded();
    }
  }

  checkIfExpanded() {
    if (this.props.expandedList.includes(this.props.i)) {
      this.setIsExpanded(true);
    } else {
      this.setIsExpanded(false);
    }
  }

  checkIfPriority() {
    if (this.props.data.__top_priority) {
      this.inactiveClasses = 'accordion__item is-top-priority';
      this.activeClasses = `${this.inactiveClasses} active`;
    }
  }

  setIsExpanded(value) {
    this.setState({
      isExpanded: value,
    }, () => {
      if (this.state.isExpanded) {
        this.setClasses(this.activeClasses);
      } else {
        this.setClasses(this.inactiveClasses);
      }
    });
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  setIsLoaded(value) {
    this.setState({
      isLoaded: value,
    });
  }

  getTopPickContent() {
    let topPickValue = null;
    if (!this.props.data) {
      this.setIsLoaded(true);
      return;
    }
    if (this.props.data.__top_pick) {
      topPickValue = this.props.data.__top_pick;
    }
    const dataId = toCamelCase(this.props.id);
    surveyContent[dataId].questions.forEach((question) => {
      if (topPickValue === question.title) {
        const topPickString = `${question.title}: ${question.desc}`;
        this.setTopPick(topPickString);
      } else {
        this.setIsLoaded(true);
      }
    });
  }

  setTopPick(value) {
    this.setState({
      topPick: value,
    }, () => {
      this.setIsLoaded(true);
    });
  }

  getElementResources() {
    const elementResources = [];
    this.props.transformationResources.forEach((resource) => {
      const resourceElId = resource.element.toLowerCase()
          .replace('&', '')
          .replace('  ', '-')
          .replace(' ', '-');
      if (resourceElId === this.props.id) {
        elementResources.push(resource);
      }
    });
    this.setResources(elementResources);
  }

  setResources(value) {
    this.setState({
      resources: value,
    });
  }

  handleLabelClick(step, element) {
    this.setState({
      activeStep: step,
    });
  }

  createReviewBars(data) {
    const reviewBars = this.props.elementSteps.map((step, i) => {
      let barValue = 0;

      if (data[step.id]) {
        barValue = setZeroIfInvalidNumber(data[step.id].__average);
      }

      const reviewBar = {
        name: step.title,
        value: barValue,
        valueFormatted: `${Math.floor(barValue * 100)}%`,
      };
      return reviewBar;
    });

    return reviewBars;
  }

  render() {
    const hasError = this.props.hasError;
    const item = this.props.item;

    if (this.state.isLoaded) {
      return (
        h('div', {
          id: this.props.id,
          key: `${item.id}-graph__key`,
          className: this.state.classes,
          dataaccordion: this.props.i,
        }, [
          h(AccordionItemHeader, {
            title: item.title,
            index: this.props.i,
            hasError,
            icon: item.icon,
            progress: hasError ? 0 : this.props.data.__average,
            progressPrev: this.props.dataPrev ?
              this.props.dataPrev.__average :
              null,
            isExpanded: this.state.isExpanded,
            handleAccordionToggle: this.props.handleAccordionToggle,
          }, null),

          h('div', {
            id: `${item.id}__accordion`,
            className: 'accordion__item__content',
          }, [
          hasError ? h(AccordianContentMinimal, {
            item,
            alternateResources: this.props.alternateResources,
          }) :
          h('div', {
            className: 'flex flex--wrap flex--align-start padding-bottom--lg-2',
          }, [
            h('div', {
              className: 'flex--half padding-right--md-2',
            }, [
              h(TooltipGroup, {
                title: item.tooltip,
              }, h(eyebrow, {
                className: 'content__title with__help_text',
              }, `${item.title} Progress Across Key Phases of Transformation`)),
                this.props.chartHelpText ? h('p', {
                  key: 'help__text__key',
                  className:
                    'p text--grey text--small footnote padding-bottom--micro',
                }, this.props.chartHelpText) : null,
                h('div', {
                  id: `${this.props.id}__chart-container`,
                  className: 'vertical-bar-chart__container',
                },
                h(BarChartVertical, {
                  key: 'element-bar-chart__key',
                  id: `${this.props.id}__graph`,
                  className: 'element-bar-chart',
                  element: this.props.id,
                  data: this.createReviewBars(this.props.data),
                  dataPrev: this.props.dataPrev ?
                    this.createReviewBars(this.props.dataPrev) :
                    null,
                  chartName: this.props.chartName,
                  chartNamePrev: this.props.chartNamePrev,
                  barWidth: 10,
                  color: '#1a73e8',
                  parentId: `${this.props.id}__chart-container`,
                  onLabelClick: this.handleLabelClick,
                  size: [540, 207],
                  activeStep: this.state.activeStep,
                }, null)
                ),
            ]),

            h('div', {
              className: 'flex--half padding-left--md-2',
            }, [
              h('div', {
                className: 'padding-bottom--lg-2',
              }, h(OverviewDetail, {item})),
              h('div', {
                className: 'padding-bottom--lg-2',
              }, [
                h(TooltipGroup, {
                  title: item.topPickTooltip,
                }, h(eyebrow, {
                  className: 'content__title',
                }, `Respondents' Top Priority`)),

                h(p, {
                  className: 'text--grey',
                }, this.state.topPick),
              ]),
            ]),
          ]),

            hasError ? null : h(AccordionItemResources, {
              id: `${this.props.id}__resources`,
              steps: item.steps,
              element: this.props.id,
              elementTitle: item.title,
              resources: this.state.resources,
              activeStep: this.state.activeStep,
            }, null),
          ]),
        ])
      );
    } else {
      return (
        h(LoadingIndicator, null, null)
      );
    }
  }
}

export default AccordionItem;
